import { auth } from '../firebaseInit';
import { onAuthStateChanged } from 'firebase/auth';

/**
 * Check if a user is currently authenticated
 * @returns {Promise<boolean>} Promise that resolves to true if user is logged in
 */
export const isAuthenticated = () => {
    return new Promise((resolve) => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            unsubscribe();
            resolve(!!user);
        });
    });
};

/**
 * Get the current authenticated user
 * @returns {Promise<object|null>} Promise that resolves to the user object or null
 */
export const getCurrentUser = () => {
    return new Promise((resolve) => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            unsubscribe();
            resolve(user);
        });
    });
};
